
<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Planes de Membresias</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="data_membresias"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <MembresiasForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
     <modal ref="modalFormBeneficios" :title="'Beneficios del plan'" v-model="showModalBeneficios" :fullscreen="true" :showFooter="false">
      <BeneficiosForm :key="keyFormBeneficios" :idPlan="idPlan"></BeneficiosForm>
     </modal>
  </div>
</template>



<script>
import uvDataTable from "../MainComponents/DataTable.vue";
import modal from "../MainComponents/modal.vue";
import MembresiasForm from "./FormPlanMembresia.vue";
import BeneficiosForm from "./Beneficios/Beneficios.vue"

export default {
  name: "Membresias",
  components: {
    uvDataTable,
    MembresiasForm,
    modal,
    BeneficiosForm,
  },
  data() {
    return {
      keyFormBeneficios:1,
      idPlan:"",
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      access: [],
      gruposCliente: [],
      showModal: false,
      showModalBeneficios:false,
      config: {
        disablePagination:true,
        selectableRow: true,
        allowExport: true,
        rawText: "Planes de membresia",
        orderByCol: { Field: "Nomb", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMembresia",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarMembresia",
            require: true,
          },
          {
            text: "Administrar Beneficios",
            icon: "lni lni-pencil-alt",
            buttonId: "adminBeneficios",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteMembresia",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nomb",
            text: "Identificador",
            value: "id",
          },
          {
            title: "Nombre",
            dataName: "Nomb",
            text: "Nombre",
            value: "Nomb",
          },
          {
            title: "Clave",
            dataName: "Cve",
            text: "Clave",
            value: "Cve",
          },
          {
            title: "Costo Anual",
            dataName: "CA",
            text: "Costo Anual",
            value: "CA",
            format: (row) => {
              return row["CA"].C+" "+row["CA"].M;
            },
          },
          {
            title: "Estatus",
            dataName: "Activo",
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              return row["Activo"] ? "Activo" : "Inactivo";
            },
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      data_membresias: [],
      data_clientes: [],
      selectedMenu: 1,
    };
  },
  computed: {},
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMembresia(data);
      } else if (doAction == "EDIT") {
        this.editarMembresia(data);
      }
    },
    async getUserGroups() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/GruposCliente")
      if (data.exists()) {
        let arrayGrupos = Object.entries(data.val());
        let grupos = [];
        arrayGrupos.forEach(function (element) {
          grupos.push({ value: element[0], text: element[1]["Nombre"] });
        });
        this.gruposCliente = grupos;
      }else{
        this.gruposCliente = [];
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMembresia") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Planes de membresia");
        this.clientAdd = {
          nombre: "",
          apellidos: "",
          correo: "",
          telefono: "",
          grupo: "",
        };
        this.toggleModal(true);
      }
      if (buttonId == "editarMembresia") {
        this.idSelected = idSelected[0];
        const cashier = this.$pgsHelper.getById(
          this.data_membresias,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$refs.modalForm.setTitle("Editar Plan de membresia");
        this.toggleModal(true);
      }
      if(buttonId =='adminBeneficios'){
        this.idPlan = idSelected[0]
        this.keyFormBeneficios++
        this.showModalBeneficios = true
        //this.$router.push({ path: "beneficios/"+idSelected[0] });
      }
      if (buttonId == "deleteMembresia") {
        this.deleteMembresia(idSelected[0]);
      }
    },
    async getMembresias() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("MBS/Planes")
      if (!data.exists()) {
        return false;
      }
      let arrayGrupos = Object.entries(data.val());
      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ id: element[0], ...element[1] });
      });
      this.data_membresias = grupos;
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    createMembresia(data) {
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"el plan de membresia",
          route:'MBS-Planes-createPlan',
          data:data,
          onSuccess:()=>{
            this.toggleModal(false);
            this.getMembresias();
          }
        })
    },
    editarMembresia(data) {
      this.$alert.alertConfirm(
        {
          action:"editar",
          obj:"el plan de membresia",
          route:'MBS-Planes-updatePlan',
          data:data,
          onSuccess:()=>{
            this.toggleModal(false);
            this.getMembresias();
          }
        })
    },
    deleteMembresia(id) {
      let datos = { Id: id };
      this.$alert.alertConfirm(
        {
          action:"eliminar",
          obj:"el plan de membresia",
          route:'MBS-Planes-deletePlan',
          data:datos,
          onSuccess:()=>{
            this.toggleModal(false);
            this.getMembresias();
          }
        })
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    this.getUserGroups();
    this.getMembresias();
  },
};
</script>




